module.exports = __webpack_public_path__ + "static/media/rest.8a3e25d8.svg";